<template>
  <Can :ability="hasAccounts">
    <SidebarGroup :group="group" />
  </Can>
</template>

<script setup lang="ts">
import type { NavGroup } from "./Group.vue";
import { useBugReportDialog } from "@/components/BugReport";

const { hasNewNotifications } = useDealerNews();
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const { hasAnyPermission } = useAppSession();

const group = computed<NavGroup>(() => {
  return {
    items: [
      {
        to: "/quotes",
        title: "Quotes",
        icon: "lucide:receipt-text",
        isActive: "startsWith",
        hidden: !hasAnyPermission("quote:read"),
      },
      {
        to: "/orders",
        title: "Orders",
        icon: "lucide:dollar-sign",
        isActive: "startsWith",
        hidden: !hasAnyPermission("order:read"),
      },
      {
        to: "/dealer-news",
        title: "Dealer News",
        icon: "lucide:gift",
        isActive: "equals",
        notification: isMounted.value && hasNewNotifications.value,
      },
      {
        to: "/resources",
        title: "Resources",
        icon: "lucide:files",
        isActive: "equals",
      },
      {
        title: "I'm Having An Issue",
        icon: "lucide:bug",
        click: () => {
          isBugReportDialogOpen.value = true;
        },
        isActive: isBugReportDialogOpen,
      },
    ],
  };
});
const { open: isBugReportDialogOpen } = useBugReportDialog();
</script>

<style scoped></style>
